"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const unwrapReadonlyObject = (original) => (Object.assign({}, original));
exports.default = unwrapReadonlyObject;
